import * as React from 'react'
import cx from 'classnames'
import styles from './UnreadCount.sass'

interface Props extends React.HTMLAttributes<HTMLSpanElement> {
  count: number
}

export default function UnreadBadge({ count, className, ...rest }: Props) {
  return (
    <span className={cx(styles.root, className)} {...rest}>
      {count > 99 ? '99+' : count}
    </span>
  )
}
